import { useRef, useState } from "react";
import { Download, FileSpreadsheet, Upload } from "lucide-react";
import { toast } from "sonner";
import { uploadSheet, errorText } from "@/lib/api";

const TEMPLATE = "Song,Film,Year,English Question,Hindi Question,Category,Number,SI,Start\nKabhi Kabhie Mere Dil Mein,Kabhi Kabhi,1976,\"Should I eat this yummy sweet dish?\",\"मैं इस पकवान को खा लूँ क्या?\",Personal,BVnz6oSupUM,,0\n";

const downloadTemplate = () => {
  const blob = new Blob(["\ufeff" + TEMPLATE], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "bollygpt_template.csv";
  a.click();
};

export const SheetUploader = ({ password, onDone, count }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [drag, setDrag] = useState(false);

  const handle = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const r = await uploadSheet(password, file);
      toast.success(`Imported ${r.imported} questions${r.missing_hindi ? ` (${r.missing_hindi} without Hindi yet)` : ""}`);
      if (r.blocked) toast.warning(`${r.blocked} video(s) have playback on other sites disabled by their owner, so visitors may see "Video unavailable" for those`);
      await onDone();
    } catch (err) {
      toast.error(errorText(err));
    } finally {
      setBusy(false);
      input.current.value = "";
    }
  };

  return (
    <section className="grid gap-6 md:grid-cols-[1fr_240px]">
      <div
        onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={(e) => { e.preventDefault(); setDrag(false); handle(e.dataTransfer.files[0]); }}
        onClick={() => input.current.click()}
        data-testid="spreadsheet-dropzone"
        className={`cursor-pointer rounded-2xl border-2 border-dashed p-10 text-center transition-colors ${drag ? "border-pink-400 bg-pink-500/10" : "border-cyan-400/50 bg-[#161926] hover:border-amber-400"}`}
      >
        <input ref={input} type="file" accept=".xlsx,.csv" className="hidden" data-testid="spreadsheet-upload-input" onChange={(e) => handle(e.target.files[0])} />
        {busy ? <FileSpreadsheet className="mx-auto h-10 w-10 animate-pulse text-amber-400" /> : <Upload className="mx-auto h-10 w-10 text-cyan-400" />}
        <p className="mt-4 font-bold text-white">{busy ? "Uploading..." : "Drop a .xlsx or .csv here, or click to choose"}</p>
        <p className="mt-2 text-xs text-slate-400">Replaces all current questions with the rows in this file. Needs columns: English Question, and either Number (the YouTube video number) or a YouTube URL. Optional: SI, Start (seconds into the video to begin), Hindi Question, Song, Film, Year, Category. Rows with no video at all are skipped.</p>
      </div>
      <div className="flex flex-col gap-4">
        <div className="rounded-2xl bg-amber-400 p-6 text-slate-900">
          <p className="text-xs font-bold uppercase tracking-widest">Live questions</p>
          <p className="font-marquee text-5xl" data-testid="questions-count-badge">{count}</p>
        </div>
        <button onClick={downloadTemplate} data-testid="download-template-button" className="flex items-center justify-center gap-2 rounded-full border border-slate-600 py-3 text-sm text-slate-200 transition-colors hover:border-amber-400 hover:text-amber-300">
          <Download className="h-4 w-4" /> Download template
        </button>
      </div>
    </section>
  );
};
